
import axios from 'axios';
import { extractData, handleApiException, handleResponse } from 'helpers/apiResponseHelper';
import { apiService } from "./api.service";

async function getLoyaltyLevels() {
    return axios.get(apiService.getApiUrl() + '/loyalty-levels')
      .then(handleResponse)
      .then(extractData)
      .catch(handleApiException);
}

const LoyaltyService = {
  getLoyaltyLevels
};

export default LoyaltyService;
